"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.InputRange = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var typography_1 = require("@kaizen/typography");
var InputRange_module_scss_1 = __importDefault(require("./InputRange.module.scss"));
var InputRange = function (props) {
    var id = props.id, defaultValue = props.defaultValue, value = props.value, minLabel = props.minLabel, maxLabel = props.maxLabel, _a = props.min, min = _a === void 0 ? 1 : _a, _b = props.max, max = _b === void 0 ? 10 : _b, onChange = props.onChange, ariaDescribedby = props["aria-describedby"], classNameOverride = props.classNameOverride, disabled = props.disabled, readOnly = props.readOnly, restProps = __rest(props, ["id", "defaultValue", "value", "minLabel", "maxLabel", "min", "max", "onChange", "aria-describedby", "classNameOverride", "disabled", "readOnly"]);
    var _c = (0, react_1.useState)(0.5), step = _c[0], setStep = _c[1]; // Let the dot center between the notch initially
    var visuallyHiddenHintId = "".concat(id, "-helper");
    var readOnlyWithNoValue = readOnly && !value && !defaultValue;
    // This has been split out into a different variable to allow usage of defaultValue above^
    // Plus it lets us use max from props with its default value
    var defaultValueWithDefault = defaultValue || (max + 1) / 2;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("input", __assign({ id: id, className: (0, classnames_1["default"])(InputRange_module_scss_1["default"].ratingScaleRange, classNameOverride, readOnlyWithNoValue && InputRange_module_scss_1["default"].hideThumb, disabled && InputRange_module_scss_1["default"].disabled), disabled: disabled || readOnly, type: "range", min: min, max: max, step: step, defaultValue: value ? undefined : defaultValueWithDefault, value: value, "aria-valuenow": value, "aria-valuemin": min, "aria-valuemax": max, "aria-describedby": "".concat(visuallyHiddenHintId, " ").concat(ariaDescribedby ? ariaDescribedby : ""), onChange: function (e) {
                setStep(1); // Put the stepper to 1 to avoid floating value
                onChange === null || onChange === void 0 ? void 0 : onChange(e);
            } }, restProps)),
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(InputRange_module_scss_1["default"].spokes, disabled && InputRange_module_scss_1["default"].disabled) }, __spreadArray([], Array(max), true).map(function (_, index) { return (react_1["default"].createElement("div", { key: "".concat(id, "-spoke-").concat(index), className: InputRange_module_scss_1["default"].spokeContainer },
            react_1["default"].createElement("div", { className: InputRange_module_scss_1["default"].spoke }))); })),
        react_1["default"].createElement("div", { className: InputRange_module_scss_1["default"].visuallyHidden, id: visuallyHiddenHintId },
            min,
            " is ",
            minLabel,
            ", ",
            max,
            " is ",
            maxLabel),
        react_1["default"].createElement("div", { className: InputRange_module_scss_1["default"].labelsContainer }, !readOnlyWithNoValue && (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(InputRange_module_scss_1["default"].sliderLabels, disabled && InputRange_module_scss_1["default"].disabled) },
            react_1["default"].createElement(typography_1.Paragraph, { variant: "small", color: "dark-reduced-opacity", tag: "span" }, minLabel),
            react_1["default"].createElement(typography_1.Paragraph, { variant: "small", color: "dark-reduced-opacity", tag: "span" }, maxLabel))))));
};
exports.InputRange = InputRange;
exports.InputRange.displayName = "InputRange";
//# sourceMappingURL=InputRange.js.map